import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage} from 'react-intl';
import ReactModal from 'react-modal';
import Box from '../box/box.jsx';
import styles from './model-loading-modal.css';

const ModelLoadingModal = props => (
    <ReactModal
        isOpen
        className={styles.modalContent}
        contentLabel="Model Loading Modal"
        overlayClassName={styles.modalOverlay}
        onRequestClose={props.onCancel}
        shouldCloseOnOverlayClick={false}
    >
        <Box className={styles.header}>
            <div className={styles.headerItem}>
                <FormattedMessage
                    defaultMessage="Information!"
                    description="Header for the model loading modal"
                    id="gui.modelLoadingModal.header"
                />
            </div>
        </Box>
        <Box className={styles.body}>
            <div className={styles.upperBody}>
                <div className={styles.iconContainer}>
                    <svg
                        className={styles.downloadIcon}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                        <polyline points="7 10 12 15 17 10"></polyline>
                        <line x1="12" y1="15" x2="12" y2="3"></line>
                    </svg>
                </div>
            </div>
            <div className={styles.lowerBody}>
                <div className={styles.message}>
                    <FormattedMessage
                        defaultMessage="Please wait while the models are being loaded..."
                        description="Message body for the model loading modal"
                        id="gui.modelLoadingModal.message"
                    />
                </div>
                <div className={styles.dots}>
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                    <div className={styles.dot} />
                </div>
                <div className={styles.buttonContainer}>
                    <button
                        className={styles.waitButton}
                        disabled
                    >
                        <FormattedMessage
                            defaultMessage="Please wait..."
                            description="Button text for the model loading modal"
                            id="gui.modelLoadingModal.pleaseWait"
                        />
                    </button>
                </div>
            </div>
        </Box>
    </ReactModal>
);

ModelLoadingModal.propTypes = {
    onCancel: PropTypes.func.isRequired
};

export default ModelLoadingModal;
